import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'barnets-navn';

        case 'barnets-navn':
            return 'sygeforsikring';

        case 'sygeforsikring':
            return 'psykisk-fysisk-skade';

        case 'psykisk-fysisk-skade':
            if (getValueOrDefault(formConfig, formValues, 'hardupsykiskellerfysiskskade').value === 'Psykisk') {
                return 'psykisk-lidelse';
            }
            return 'fysisk-skade';

        case 'psykisk-lidelse':
            return 'om-psykisk-lidelse';

        case 'om-psykisk-lidelse':
            return 'dato';

        case 'fysisk-skade':
            return 'om-fysisk-skade';

        case 'om-fysisk-skade':
            return 'beskriv-skaden';

        case 'beskriv-skaden':
            return 'dato';

        case 'dato':
            return 'tidligere-behandling';

        case 'tidligere-behandling':
            if (
                getValueOrDefault(formConfig, formValues, 'hardensammesygdomskadetidligerevretbehandlet').value === 'Ja'
            ) {
                return 'dato-for-seneste-behandling';
            }
            return 'henvisning-anbefaling';

        case 'dato-for-seneste-behandling':
            return 'henvisning-anbefaling';

        case 'henvisning-anbefaling':
            if (
                getValueOrDefault(
                    formConfig,
                    formValues,
                    'hardensygeskadedefetenhenvisningelleranbefalingtilbehandlingellerundersgelse'
                ).value === 'Ja'
            ) {
                return 'hvilken-henvisning-anbefaling';
            }
            return 'hvilken-behandling';

        case 'hvilken-henvisning-anbefaling':
            return 'behandling';

        case 'hvilken-behandling':
            return 'behandling';

        case 'behandling':
            if (getValueOrDefault(formConfig, formValues, 'erdubegyndtibehandling').value === 'Ja') {
                return 'behandling-start';
            }
            return 'dokumentation';

        case 'behandling-start':
            return 'dokumentation';

        case 'dokumentation':
            return 'om-dig';

        case 'om-dig':
            return 'resume';

        case 'resume':
            return undefined;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
